if (!customElements.get('product-card')) {
  customElements.define(
    'product-card',
    class ProductCard extends HTMLElement {
      constructor() {
        super();
        this.onSubscribeChange = this.onSubscribeChange.bind(this);
      }

      connectedCallback() {
        this.subscribeInput = this.querySelector('.product-card__subscribe-input');
        this.sellingPlanInput = this.querySelector('.product-card__selling-plan');
        this.priceEl = this.querySelector('.product-card__atc-price');
        this.priceData = this.querySelector('.product-card__price-data');

        if (!this.subscribeInput) return;

        this.subscribeInput.addEventListener('change', this.onSubscribeChange);
        this.onSubscribeChange();
      }

      disconnectedCallback() {
        this.subscribeInput?.removeEventListener('change', this.onSubscribeChange);
      }

      onSubscribeChange() {
        const checked = Boolean(this.subscribeInput?.checked);

        if (this.sellingPlanInput) {
          this.sellingPlanInput.disabled = !checked;
          this.sellingPlanInput.value = checked ? this.subscribeInput.dataset.sellingPlanId || '' : '';
        }

        if (this.priceEl && this.priceData) {
          this.priceEl.textContent = checked
            ? this.priceData.dataset.sellingPlanPrice
            : this.priceData.dataset.regularPrice;
        }
      }
    }
  );
}
